<template>
   <div class="vertical-center " > 
      <div class="container  ">
         <div class="card login" >
            <div class="card-body">
               <div class="name">
<!--                 <img  :src="image" /> -->
<!--                <h2>Qaller</h2> -->
<!--                 Quality Radio Caller App  -->
                <!-- <img class="logo" src="../assets/images/qaller.png" /> -->
               <p class="talk">Talk</p>
               </div>
               <form @submit.prevent="login"  class="text-center" >
                  <div class="form-group">
                     <div v-if="this.$route.query.uuid" class="welcome_invitee">
                        Welcome <b>{{invitee_name}}</b>,
                        Click the 'Initiate Call' button to initate a call with <b>{{sender}}</b> 
                     </div>
                     <input  v-if="!this.$route.query.uuid" type="text" class="form-control" placeholder="Please enter your name....." name="name" v-model="name"  v-on:keyup="clearError"  >
                     <p v-if="errorText" class="text-danger">{{errorText}}</p>
<!--                      <p v-if="errorText" class="text-danger">{{errorText}}</p> -->
                  </div>
                  <div  class="alert alert-info" >
                     Your browser will ask you to allow the use of your microphone. You MUST allow this. If you do not allow the use your microphone, no-one will be able to hear you.
                  </div>
                     <button class="btn btn-primary" v-if="!this.$route.query.uuid" ref="submitBtn">Login</button>
                     <button class="btn btn-primary" v-if="this.$route.query.uuid" @click="initiate_call" >Initate Call</button>
               </form>
            </div>
         </div>
      </div>
      <!-- <button v-on:click="Check2"> 123 </button> -->
   </div>
</template>

<script>

   import image from "../assets/images/logo.png"
   import {isMobile} from 'mobile-device-detect';
   import {micSource, vuVis , Ring} from '../../public/js/helper.js';
   import {wsSock} from '../../public/js/comms.js';
   import json_errorText from './../assets/JSON/errorText.json';
  
export default {
   name : 'Login',
   props : {
      errText: String,
   },
   data() {
      return {
         name: "" ,
         errorText:null,
         image : image,
         ctx : null,
         mic: null , 
         got_mic : null , 
         micvis: null ,
         ring : null, 
         wss : null,
         peers: {},
         errorTranslation: json_errorText,
         date: new Date(),
         is_accepted: null,
         hav_invitee_detail: null,
         change_component: null,
         invitee_name : null, 
         sender : null 
      }
   },
   beforeMount() {
      this.wss  = new wsSock(),
      this.wss.open();
      this.wss.onpeer = this._onpeer.bind(this);

      this.errorText = this.errText;
      this.wss.onreject = (call, id) => {
         if(call == 'setid') {
            this.errorText = "The name '"+id+"' is currently in use. Please enter a different name" ;
         }
      };

      this.change_component = (id) => {
         // alert('change_component');
         // alert('Called by : '+ id);
         if(this.is_accepted && this.mic && this.ring) {
            console.log('this.is_accepted: ' + this.is_accepted);
            console.log('this.mic: ' + this.mic);
            console.log('this.ring: ' + this.ring);
            console.log('query.uuid: ' + this.$route.query.uuid);
            // alert('HOST1');

            if(!this.$route.query.uuid) {
                  // alert('GO HOST');
                  this.$router.push({
                     name : 'Host',
                     params : {
                        wss : this.wss, 
                        username : this.name, 
                        studiocaller : this, 
                        isMobile : isMobile, 
                        mic : this.mic, 
                        ctx : this.ctx,
                        date : this.date
                     },
                  })
            } 
         }   
      }
      
      // var is_set_id = false; 
      this.wss.onaccept = (call, data) => {
         if(call == 'setid') {
            this.is_accepted = true;
            // if(this.is_accepted) {this.change_component('onaccept1')};
            this.change_component('Onaccept')
         }
         if(this.$route.query.uuid) {
            if(call == 'db' && data.cmd =="db_fetch_invitee") {
               this.hav_invitee_detail = true;
               // this.change_component('db_fetch');
               var invitee = JSON.parse(data.data);
               console.log(invitee);
               this.invitee_name = invitee[0].name ; 
               this.sender = invitee[0].sender;
               
               this.wss.invitee_detail = invitee; 

               if(this.invitee_name) {
                  this.setID(this.invitee_name );
                  if(this.invitee_name ) {
                     localStorage.name = this.invitee_name ; 
                  }
                  if(isMobile) {
                     this.wss.send({cmd:'log', data: 'user: '+this.invitee_name +' -> Mobile device detected'});
                     this.setid(1);
                  } else {
                     this.setid(0);
                     this.wss.send({cmd:'log',data:'user: '+this.invitee_name +' -> Non-mobile device detected'});
                  }
               }

            }
         }
      };

      this.wss.onalert = (t) => {
         this.errorText = 'wss : '+t; 
         localStorage.errorText = 'wss : '+t;
         t  = t.replace(/ *\([^)]*\) */g, " ");
         t  = t.replace("+ act  +","");
         var replaced_key  = '' ; 
         this.errorText = '';
         for (var  key in json_errorText) {
               var  value = json_errorText[key];
               replaced_key  = key.replace("+ act  +","");
               replaced_key = "wsSock: "+ replaced_key ;
               if(replaced_key  == t ) {
                     this.errorText = value ;
                     if (value == "The connection to the server has been lost" ) {
                        value = '';
                        localStorage.errorText = value;
                        document.location.reload(true); 
                     }

                  this.errorText = value;
               }
         }
         console.log('wss : '+t);
      }
   },
   mounted:function() {
      if (localStorage.name) {
         this.name = localStorage.name;
      }   
      if(localStorage.errorText) {
         this.errorText= localStorage.errorText ;
         window.localStorage.removeItem('errorText');
      } 
      this.wss.onclose = () => {
         this.wss.send({cmd:'log', data: this.date+' user: '+this.name+' -> : Login Comp. :  onclose callback function'});
         this.$forceUpdate();
      };
      window.onpopstate = function(event) {
         location.reload();
      };
      this.wss.onopen = () => {
         this.invitee_check();
      } ;
   },
   methods: {
      login() {
         // alert('CHECK');
         if (!this.$route.query.uuid) {
            this.name = this.name.trim();
            if(this.name) {
               this.setID(this.name);
               if(!this.errorText) {
                  if(this.name) {
                     localStorage.name = this.name; 
                  }
                  if(isMobile) {
                     this.wss.send({cmd:'log', data: 'user: '+this.name+' -> Mobile device detected'});
                     this.setid(1);
                  } else {
                     this.setid(0);
                     this.wss.send({cmd:'log',data:'user: '+this.name+' -> Non-mobile device detected'});
                  }
               }
            } else {
               this.errorText = "Please enter a name" 
            }
         } else {
            var _this = this;
            _this.$router.push({
                  name : 'Home',
                  params : {
                     wss : _this.wss, 
                     username : localStorage.name, 
                     studiocaller : _this, 
                     isMobile : isMobile, 
                     mic : _this.mic, 
                     ctx : _this.ctx,
                     date : _this.date
                  },
            })
         }
      },
      initiate_call(){

         // if(invitee_name) {
         //    // this.setID(invitee_name);
         //    if(invitee_name) {
         //       localStorage.name = invitee_name; 
         //    }
         //    if(isMobile) {
         //       this.wss.send({cmd:'log', data: 'user: '+invitee_name+' -> Mobile device detected'});
         //       this.setid(1);
         //    } else {
         //       this.setid(0);
         //       this.wss.send({cmd:'log',data:'user: '+invitee_name+' -> Non-mobile device detected'});
         //    }
         // }

      },
      // change_component() {
      //    // alert('YES!!!!!');
      // },
      setID(name) {
         return this.wss.setid(name);
      },
      get_onpeer() {
         return this.wss.peers;
      },
      _onpeer() {
         this.peerPar = '';
         var ringing = false;
         Object.keys(this.wss.peers).forEach((id,_) => {
            var p = this.wss.peers[id];
            if(p.deleted) {
               delete this.wss.peers[id];
            }
         });
      },
      open() {
         console.log('app open');
         this.wss.open();
      },
      close() {
         this.wss.send({cmd:'log', data: 'user: '+this.name+' -> : Login Comp. : close Method'});
         this.wss.close();
      },
      setid(lite) {
         console.log('app setid: ' + lite);
         if(!this.ctx) {
            let AudioContext = window.AudioContext || window.webkitAudioContext;
            this.ctx = new AudioContext();
         }
         if(!this.ring) {
            this.ring = new Ring(this.ctx);
            this.ring.onload = (e) => {
               this.change_component('ring');
               console.log('LOADED AUDIO: ', e);
            };
            this.ring.load('ring3', '../sounds/ring3.u16');
            // alert('ring');
         }
         if(!this.mic) {
            this.mic = new micSource(this.ctx);
            // alert('onopentest1');
            this.mic.onopen = () => {
               console.log('got mic: ', lite);
               if(lite) {
                  this.wss.setaudio(this.ctx, this.mic._stream);
               } else {
                  this.wss.setaudio(this.ctx);
               }
               this.got_mic = true;
               this.wss.onpeer(); // update peer display once mic is open...
               // alert('Mic');
               this.change_component('mic');
            }
         }
      },
      create_canvas(micCanvas) {
         if(!this.micvis) {
            this.micvis = new vuVis(this.ctx, micCanvas);
            console.log('MicVis: ');
            console.log(this.micvis);
            this.mic.connect(this.micvis);
         }
      },
      clearError() {
         this.errorText = '';
      },
      invitee_check() {
         if(this.$route.query.uuid) {
            if(this.$route.query.uuid.match(/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i)) {
               this.wss.send({cmd:'db', data: {act: "fetch_invitee_details", data: {uuid:this.$route.query.uuid}}});
            }
         }
      },
      login_test() {
         console.log('login_test');
         console.log(localStorage.name);
         this.setID(localStorage.name);
      },
   },
   updated: function () {
      this.$nextTick(function () {
         // Code that will run only after the
         // entire view has been re-rendered
         // alert('ASD');
         // this.Check1(); 
      })
   }
}
</script>

<style>
   .login {
      max-width   : 450px; 
      margin      : 50px;
      display     : block; 
      margin-left : auto; 
      margin-right: auto ; 
   }
   .vertical-center {
      min-height: 100%; 
      min-height: 90vh;
      display: flex ;
      align-items: center;
   }
   .name {
      margin-bottom: 5px;
   }
   
   .logo {
      width : 120px;
      display: block;
      margin-left: auto;
      margin-right: auto;
   }

   .text-danger{
      text-align: justify;
      margin : 10px 0 10px 0;
   }
   .welcome_invitee{

   }
   
</style>
